
import gsap from 'gsap';
import { NineSlicePlane, Texture } from 'pixi.js';
import { Shared } from '../../App';
import { RectangleButton, RectangleButtonOpts } from './RectangleButton';

export class ShopConfirmButton extends RectangleButton
{
    
    private defaultBgTexture: Texture;
    
    constructor(opts: Partial<RectangleButtonOpts> = {})
    {
        super(opts);
        
        this.defaultBgTexture = this.bg.texture;
    }
    
    public enable(){
        this.enabled = true;
        
        this.bg.texture = this.defaultBgTexture;
    }
    
    public disable(){
        this.enabled = false;
        
        gsap.killTweensOf(this.view.scale);
        this.view.scale.set(1);
        
        this.bg.texture = Shared.assets.getTexture("button-ninesliced-grey");
        
    }

}
